import React, { useState } from "react";
import { Link } from "gatsby";
import styled from 'styled-components';
import logo from '../assets/images/Transnet_Logo_2013.svg';
import hamburger from '../assets/images/hamburger.svg';
import close from '../assets/images/x.svg';

const NavStyles = styled.nav`
    background: rgb(146,133,81);
    background: linear-gradient(0deg, rgba(146,133,81,1) 0%, rgba(146,133,81,1) 40%, rgba(146,133,81,0.4) 70%, rgba(146,133,81,1) 90%, rgba(146,133,81,1) 100%),
    linear-gradient(white, white);
    height: 50px;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas: "logo menu-list";
    position: relative;
    z-index: 2;
    /* margin-bottom: 50px; */
    
    img {
      max-width: 250px;
      padding: 10px 20px;
      position: relative;
      grid-area: logo;
    }

    ul {
      margin: 0;
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      list-style: none;
      position: relative;
      grid-area: menu-list;
    }

    li {
      width: 100%;
      background-color: var(--grey);
      margin: 5px;
      transform: skewX(-20deg);
      text-transform: uppercase;
      border-radius: 0.4rem;
      background-image: linear-gradient(180deg, hsl(0,0%,78%)  0%, hsl(0,0%,90%) 47%, hsl(0,0%,78%) 53%, hsl(0,0%,70%)100%);
      color: hsla(0,0%,20%,1);
      text-shadow: hsla(0,0%,40%,.5) 0 -1px 0, hsla(0,0%,100%,.6) 0 2px 1px;
      background-color: hsl(0,0%,90%);
      box-shadow: inset hsla(0,0%,15%,  1) 0  0px 0px 1px, /* border */
      inset hsla(0,0%,15%, .8) 0 -1px 5px 2px, /* soft SD */
      inset hsla(0,0%,0%, .25) 0 -1px 0px 2px, /* bottom SD */
      inset hsla(0,0%,100%,.7) 0  2px 1px 2px, /* top HL */
      hsla(0,0%, 0%,.15) 0 -7px 6px 1px, /* outer SD */
      hsla(0,0%,0%,.5) 0  3px 6px 1px; /* outer HL */ 
      text-align: center;
    }

    li:hover {
      color: hsl(210, 100%, 40%);
      text-shadow: hsla(210,100%,20%,.3) 0 -1px 0, hsl(210,100%,85%) 0 2px 1px, hsla(200,100%,80%,1) 0 0 5px, hsla(210,100%,50%,.6) 0 0 20px;
      box-shadow: 
      inset hsla(210,100%,30%,  1) 0  0px 0px 1px, /* border */
      inset hsla(210,100%,15%, .4) 0 -1px 5px 2px, /* soft SD */
      /*inset hsla(210,100%,20%,.25) 0 -1px 0px 2px, /* bottom SD */
      /*inset hsla(210,100%,100%,.7) 0  2px 1px 7px, /* top HL */
      
      hsla(210,100%,75%, .8) 0  0px 3px 1px, /* outer SD */
      hsla(210,50%,40%, .25) 0 -5px 6px 1px, /* outer SD */
      hsla(210,80%,85%,   1) 0  5px 6px 2px; /* outer HL */
      }

      a {
          display: block;
          text-decoration: none;
          color: black;
          padding: 10px;
          font-family: Roboto-Medium;
      }

      .hamburger-btn {
        padding: 0;
        cursor: pointer;
        transform: none;
      }

      .mobile-menu {
        display: none;
      }

    @media screen and (max-width: 1000px) {

      grid-template-columns: 50px 1fr;
      grid-template-areas: "menu-list logo";
      z-index: 2;

      .mobile-menu {
        display: block;
      }

      .desktop-menu {
        display: none;
      }
      
      ul {
        flex-direction: column;
        position: absolute;
        background-color: var(--grey);
        top: 25px;
        left: 10px;
        align-items: flex-start;
        justify-content: start;
        border-radius: 0.4rem;
        background-image: linear-gradient(180deg, hsl(0,0%,78%)  0%, hsl(0,0%,90%) 47%, hsl(0,0%,78%) 53%, hsl(0,0%,70%)100%);
        color: hsla(0,0%,20%,1);
        text-shadow: hsla(0,0%,40%,.5) 0 -1px 0, hsla(0,0%,100%,.6) 0 2px 1px;
        background-color: hsl(0,0%,90%);
        box-shadow: inset hsla(0,0%,15%,  1) 0  0px 0px 1px, /* border */
        inset hsla(0,0%,15%, .8) 0 -1px 5px 2px, /* soft SD */
        inset hsla(0,0%,0%, .25) 0 -1px 0px 2px, /* bottom SD */
        inset hsla(0,0%,100%,.7) 0  2px 1px 2px, /* top HL */
        hsla(0,0%, 0%,.15) 0 -7px 6px 1px, /* outer SD */
        hsla(0,0%,0%,.5) 0  3px 6px 1px; /* outer HL */ 
      }

      li {
        border: none;
        box-shadow: none;
        background: none;
        min-width: 200px;
        text-align: left;
        transform: none;
        margin-left: 0;
      }

      .hamburger-btn {
        display: block;
        background: none;
        border: none;
        padding: 10px;
        width: 100%;
        text-align: left;
        margin: 0;
        outline: none;
      }

      .close-btn {
        border: none;
        background: none;
        position: absolute;
        top: 0;
        right: -10px;
        cursor: pointer;
        outline: none;
      }

      li:hover {
        color: hsl(210, 100%, 40%);
        text-shadow: hsla(210,100%,20%,.3) 0 -1px 0, hsl(210,100%,85%) 0 2px 1px, hsla(200,100%,80%,1) 0 0 5px, hsla(210,100%,50%,.6) 0 0 20px;
        box-shadow: none;
      }

      li:nth-child(8) {
        margin-bottom: 20px;
      }
      
      

      img {
        justify-self: center;
      }

      .hamburger-btn > img {
        margin: 0;
        padding: 0;
      }
    }

    @media screen and (max-width: 400px) {
      img {
        justify-self: flex-end;
        max-width: 200px;
        padding-top: 15px;
      }

      ul {
        top: 30px;
      }

      .close-btn {
        top: -5px;
      }

      .hamburger-btn > img,
      .close-btn > img {
        max-width: 15px;
      }
    }

    @media screen and (max-width: 300px) {
      img {
        max-width: 150px;
        padding-top: 25px;
      }

      .close-btn {
        top: -15px;
      }
    }
`;

export default function Nav() {

  const [menuOpen, setMenuOpen] = useState(false);

  function toggleMenu() {
    setMenuOpen(!menuOpen);
  }

  return (
    <NavStyles>
      <img src={logo} alt='logo' />
      <ul className="desktop-menu">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/services">Services</Link></li>
          <li><Link to="/process">Our Process</Link></li>
          <li><Link to="/clients">Our Clients</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <li><Link to="/quote">Quote</Link></li>
      </ul>
      <ul className="mobile-menu">
          <button className="hamburger-btn" onClick={toggleMenu}><img src={hamburger} alt='hamburger button' /></button>
          {menuOpen? <>
          <button className="close-btn" onClick={toggleMenu}><img src={close} alt='close button' /></button>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/services">Services</Link></li>
          <li><Link to="/process">Our Process</Link></li>
          <li><Link to="/clients">Our Clients</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <li><Link to="/quote">Quote</Link></li></> : null}
      </ul>
    </NavStyles>
  )
}